import fetch,{postFrom,getBlob} from '../utils/fetch';

export function confirmOrderList(params) {
  return fetch({
    method: 'GET',
    url: '/contractConfirmOrder/findConfirmOrderList',
    params:params
  })
}
export function saveOrUpdate(params) {
  return fetch({
    method: 'POST',
    url: '/contractConfirmOrder/addOrUpdate',
    data:params
  })
}


export function findOrderListById(fid,businessFid) {
  return fetch({
    method: 'GET',
    url: '/contractConfirmOrder/findOrderListById',
    params : {
      fid,
      businessFid
    }
  })
}

export function confirmOperate(params) {
  return fetch({
    method: 'POST',
    url: '/contractConfirmOrder/confirmOperate',
    data:params
  })
}

export function delOperate(params) {
  return fetch({
    method: 'POST',
    url: '/contractConfirmOrder/delOperate',
    data:params
  })
}

export function getSumAmountOrder(params) {
  return fetch({
    method: 'POST',
    url: '/contractConfirmOrder/getSumAmountOrder',
    data:params
  })
}


export function getConfirmOrderStatus() {
  return fetch({
    method: 'GET',
    url: '/contractConfirmOrder/getConfirmOrderStatus',
    data:null
  })
}


export function exportOrderCount(params) {
  return fetch({
    method: 'POST',
    url: '/contractConfirmOrder/exportOrderCount',
    data:params
  })
}


export function downloadOrderList(data) {
  return getBlob({
    method: 'POST',
    url: '/contractConfirmOrder/downloadOrderList',
    data
  })
}
